module.exports = __webpack_public_path__ + "static/media/joinus.683041f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/joinus.jpg
// module id = 321
// module chunks = 0